import { useState, useEffect, forwardRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import PropTypes from 'prop-types';
import styledComponents from "styled-components";

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputBase,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

const Container = styledComponents.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`;

const Info = () => {
    return (
        <Container>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography id="modal-modal-title" variant="h6">
                        Informasi Penting Mitra Wanoja
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography fontWeight="700" color="primary">Kumpulan link</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container alignItems="center">
                                <Grid item xs={6} align="center">
                                    <a
                                        href="https://drive.google.com/drive/u/1/folders/1As2o3qWU0mDTrQ-5sRWwA7NbHc7owiX1"
                                        target="_blank"
                                    >
                                        <DownloadIcon fontSize="large" />
                                    </a>
                                </Grid>
                                <Grid item xs={6} align="left">
                                    <Typography variant="body2">Foto Produk</Typography>
                                </Grid>
                                <Grid item xs={6} align="center">
                                    <a
                                        href="https://drive.google.com/drive/u/1/folders/1_P8QEjbBMy6h7dmBwNP9FLlhle7jy1EJ"
                                        target="_blank"
                                    >
                                        <DownloadIcon fontSize="large" />
                                    </a>
                                </Grid>
                                <Grid item xs={6} align="left">
                                    <Typography variant="body2">Unduh Logo</Typography>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography fontWeight="700" color="primary">Kontak Penting</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body2">Teh Ulfah : <a href="tel:+628156030650">+628156030650</a></Typography>
                            <Typography variant="body2">Abah Asep : <a href="tel:+6285722289656">+6285722289656</a></Typography>
                            <Typography variant="body2">Pa Miftah : <a href="tel:+6285222668906">+6285222668906</a></Typography>
                            <br/>
                            <Divider />
                            <br/>
                            <Typography variant="body2">Admin CS : Delita (<a href="tel:+6289655775486">+6289655775486</a>)</Typography>
                            <Typography variant="body2">CS1 : Intan (<a href="tel:+6289655775471">+6289655775471</a>)</Typography>
                            <Typography variant="body2">CS2 : Daniar (<a href="tel:+628986480323">+628986480323</a>)</Typography>
                            <Typography variant="body2">CS3 : Zahra (<a href="tel:+6281286236131">+6281286236131</a>)</Typography>
                            <Typography variant="body2">CS4 : Yara (<a href="tel:+6289655775473">+6289655775473</a>)</Typography>
                            <br/>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography fontWeight="700" color="primary">Social Media</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container alignItems="center">
                                <Grid item xs={1} align="center">
                                    <InstagramIcon fontSize="small" />
                                </Grid>
                                <Grid item xs={11} align="left">
                                    <Typography>
                                        <b>Official</b>: @wnj.co.id
                                    </Typography>
                                </Grid>        

                                <Grid item xs={1} align="center">
                                    <InstagramIcon fontSize="small" />
                                </Grid>
                                <Grid item xs={11} align="left">
                                    <Typography>
                                        <b>Katalog</b>: @katalogwanoja
                                    </Typography>
                                </Grid>

                                <Grid item xs={1} align="center">
                                    <FacebookIcon fontSize="small" />
                                </Grid>
                                <Grid item xs={11} align="left">
                                    <Typography>
                                        <b>Fanspage</b>: wanojahijab
                                    </Typography>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography fontWeight="700" color="primary">Rekening Pusat</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body2">
                            a.n. <b>Maria Ulfah Fathimah, M.Hum.</b> <br/>
                            Mandiri 130 00 1771521 3 <br/>
                            Muamalat 110 000 3930 <br/>
                            Bank Syariah Indonesia (BSI) 7105696706 <br/>
                            <hr />
                            a.n <b>Nunung Nurhayati</b><br />
                            Mandiri 173 00 1459552 5<br />
                            BRI 114101014094501 <br/>
                            BCA 2230917275 <br/>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography fontWeight="700" color="primary">Alamat Pusat</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                            <b>Wanoja Hijab</b> <br/>
                            Jl. Guntursari Wetan No.19. <br />
                            kel. Turangga, Kec. Lengkong. <br />
                            Kota Bandung, Jawa Barat 40264. <br />
                            Indonesia <br />
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Info
